export const getUserSymbol = Symbol('onLoggedIn')
export const alertsSymbol = Symbol('alerts')
export const alertSymbol = Symbol('alert')
export const licensesSymbol = Symbol('licenses')
